// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/So_AdditionalServiceFiscalMissingResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/additional_service_fiscal/missing
 *
 * The catalog-fiscal readiness list: active additional services with no
 * effective LC116 code. Feeds the SERVICO_ADICIONAL_SEM_CODIGO_FISCAL
 * pre-flight check (InvoiceService::collectAdditionalServiceFiscalBlockers()).
 */
import type { So_AdditionalServiceFiscalMissingRow } from './So_AdditionalServiceFiscalMissingRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type So_AdditionalServiceFiscalMissingResponseDados = So_AdditionalServiceFiscalMissingRow[];

export type So_AdditionalServiceFiscalMissingResponse = ApiResponse<So_AdditionalServiceFiscalMissingResponseDados>;

registerResponseContract('So_AdditionalServiceFiscalMissingResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_additional_service_id:   { type: 'number',  required: true },
      so_additional_service_name: { type: 'string',  required: true },
    },
  },
})
